import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {OrganizationService} from "../../services/organization.service";
import {NavigationService} from "../../services/navigation.service";
import {AuthenticationService} from "../../services/authentication.service";

@Component({
  selector: 'app-organization-details',
  templateUrl: './organization-details.component.html',
  styleUrls: ['./organization-details.component.css']
})
export class OrganizationDetailsComponent implements OnInit {

  organizationId: string | null
  organization: any
  searchTerm :string
  loading = true

  constructor(private route: ActivatedRoute,
              private router: Router,
              private organizationService: OrganizationService,
              public authenticationService: AuthenticationService){
  }

  canManage(): boolean {
    return this.authenticationService.canManageOrg(Number(this.organizationId));
  }

  ngOnInit() {
    this.getOrganizationId()
    this.getOrganizationById(this.organizationId? this.organizationId : "")
  }

  getOrganizationId(){
    this.organizationId = this.route.snapshot.paramMap.get('organizationId');
  }

  getOrganizationById(organizationId: string) {
    this.loading = true
    this.organizationService.getOrganizationById(organizationId).subscribe({
      next: response => {
        this.organization = response
        this.loading = false
      },
      error: () => {
        // 403/404 etc. — render no UI for this organization.
        this.organization = null
        this.loading = false
      },
    })
  }

  receiveSearchTerm(event: string){
    this.searchTerm = event
  }

  goToOrganizationEditing(){
    this.router.navigate([NavigationService.ORGANIZATIONCREATOR + '/' + this.organizationId])
  }

  goToFacilityCreation(){
    this.router.navigate([NavigationService.FACILITYCREATOR], {relativeTo:this.route})
  }

}
